/*
  ----------------------------------------------------------------------------
    Section: FAQ Section
    - FAQ General section displayed in an accordion
  ----------------------------------------------------------------------------
*/
class FAQAccordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const question = this.querySelector(".faq__question-container");
    const answer = this.querySelector(".faq__answer-container");

    if (answer.getAttribute("aria-hidden") == "false") {
      question.classList.add('open');
    }

    question.addEventListener("click", () => {
      question.classList.add('open');
      if (answer.getAttribute("aria-hidden") == "false") {
        answer.setAttribute("aria-hidden", "true");
        question.classList.remove('open');
      } else {
        answer.setAttribute("aria-hidden", "true");
        question.classList.add('open');
        if (answer.getAttribute("aria-hidden") == "true") {
          answer.setAttribute("aria-hidden", "false");
        }
      }
    });
  }
}
customElements.define("pdp-faq", FAQAccordion);